export default "__VITE_PUBLIC_ASSET__b879f869__"